import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export { cx, sortCx } from './cx';
export { isReactComponent, isFunctionComponent, isClassComponent, isForwardRefComponent } from './is-react-component';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
